import React, { useEffect, useState } from 'react';
import './index.scss';
import {
    Col,
    Row,
    Tabs,
    Typography,
    Card, List, notification, Skeleton, Menu, Tag, Layout, Divider, Button, Input, Checkbox, Spin, Modal, Tooltip,
} from 'antd';
import API_SERVICE from 'shared/services/api-service';
import { useParams, Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    PlayCircleTwoTone,
    FolderOpenTwoTone,
    LeftOutlined,
    RightOutlined,
    FullscreenOutlined,
    FullscreenExitOutlined,
    QuestionCircleTwoTone, EyeFilled,
} from '@ant-design/icons';
// @ts-ignore
import moment from 'moment';

import { AuthConsumer } from 'shared/contexts/AuthContext';
import { useFullscreen, useLocation } from 'react-use';
import Parameters from 'shared/parameters';
import { getAttachmentsUrl, getImageUrl } from 'shared/services/Utility';
import benefitCheck from '../../img/benefit-check.png';
const { TabPane } = Tabs;
const { Content, Sider } = Layout;
const { Title, Text } = Typography;
let vidQuiz: any;
export default function ContentDetailsPage() {
    const RouteParams: any = useParams();
    const history: any = useHistory();
    const { t }: any = useTranslation();
    const [modal, contextHolder] = Modal.useModal();
    const [loading, setLoading] = useState(true);
    const [submittingQuestion, setSubmittingQuestion] = useState(false);
    const [showQuizCompletionData, setShowQuizCompletionData] = useState(null as any);
    const [fullScreen, setFullScreen] = useState(false);
    const [contentQuiz, setContentQuiz] = useState(null as any);
    const [videoQuiz, setVideoQuiz] = useState(null as any);
    const [videoQuizContent, setVideoQuizContent] = useState(null as any);
    const [loadingContent, setLoadingContent] = useState(false);
    const [course, setCourse] = useState(null as any);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [meetings, setMeetings] = useState([] as any[]);
    const [contentType, setContentType] = useState('' as any);
    const [videoId, setVideoId] = useState('' as any);
    const [toggleStarter, setToggleStarter] = useState(true as boolean);
    const [vidCurrentTime, setVidCurrentTime] = useState(0 as any);
    const location = useLocation();
    let content: any;
    const [iframeScormUrl, setIframeScormUrl] = useState('');
    
    var supposedCurrentTime = vidCurrentTime;

    let uploadedVideo = document.getElementById('uploadedVideo') as any;
    console.log("dom check", uploadedVideo);
    var lastTimeUpdate:any = 0;
    if(uploadedVideo != null) {
      
        console.log("else condition", uploadedVideo);
        if(uploadedVideo != null && uploadedVideo.getAttribute('listener') !== 'true'){
            console.log("clearing setinterval", uploadedVideo);
                        
            uploadedVideo.addEventListener('loadedmetadata', async function (e:any) {
               
                uploadedVideo.removeEventListener('pause', videoStoppedPlaying);
                uploadedVideo.removeEventListener('ended', videoStoppedPlaying);
                uploadedVideo.removeEventListener('timeupdate', updatedTime);
                uploadedVideo.removeEventListener('seeking', checkVidSeeking);

                const elementClicked = e.target;
                elementClicked.setAttribute('listener', 'true');
                console.log('event has been attached from else');
                setVidCurrTimeOnLoad();
                uploadedVideo.addEventListener('ended', completeOnVideoEnd);
                uploadedVideo.addEventListener('pause', videoStoppedPlaying);
                uploadedVideo.addEventListener('timeupdate', updatedTime);
                uploadedVideo.addEventListener('seeking', checkVidSeeking);
                
            });
            
        }
    }
    function updatedTime(){
        vidTimeUpdate(uploadedVideo)
    }
    function checkVidSeeking(){
        vidSeeking(uploadedVideo)
    }
    function vidSeeking(e : any){
        var delta = e.currentTime - supposedCurrentTime;
        if (Math.abs(delta) > 0.01 && e.currentTime > supposedCurrentTime) {
            console.log("Seeking is disabled");
            e.currentTime = supposedCurrentTime;
        }
    }
    function vidTimeUpdate(e : any) {
        let currentTime = Math.round(e.currentTime);

            if (!e.seeking) {
                supposedCurrentTime = e.currentTime;
                if(currentTime != lastTimeUpdate && (currentTime!=0)){
                    console.log("setInterval per second ",currentTime, lastTimeUpdate, new Date())
                    console.log("vidQuiz",vidQuiz, e.currentTime)
                                    
                    vidQuiz && vidQuiz.map((contentVideoQuiz : any) => {
                        if(Math.round(e.currentTime) == contentVideoQuiz?.opensAt){
                            setVideoQuiz(contentVideoQuiz)
                            console.log("hittd", Math.round(e.currentTime), contentVideoQuiz?.opensAt)
                            console.log(e.currentTime)
                            let bodyTag = document.getElementById("body") as HTMLElement
                            let VideoQuizModal = document.getElementById("VideoQuizModal") as HTMLElement
                            VideoQuizModal.style.display = "block";
                            bodyTag.style.overflow = 'hidden';
                        }
                    })
                }      
            }

        lastTimeUpdate = Math.round(e.currentTime);
    }
    function pauseVideo(){
        videoPause(uploadedVideo);
    }
    function videoPause(e :any) {
        e.pause();
    }
    function continueVideo() {
        continueVideoAfterQuiz(uploadedVideo);
    }
    function continueVideoAfterQuiz(e: any){
        //  e.currentTime = vidCurrentTime + 2;
        e.play();
    }
    function completeOnVideoEnd(){
        refreshCourseComplete();
        refreshAddProgress();
    }

    // prevent seeking/forwarding on uploaded video end
    const getCurrTime = () => {
        API_SERVICE.getVideoCurrTime(RouteParams['id']).then(({data: {data : time}}) => {
            console.log('get curr value',time)
            console.log('data.data.currenttime',time?.currenttime)
            setVidCurrentTime(time ? time?.currenttime : 0)
        }) 
    }
    function setVidTime(e : any){
        console.log('vidCurrentTime in function',vidCurrentTime)
        e.currentTime = vidCurrentTime;
    }
    function setVidCurrTimeOnLoad(){
        setVidTime(uploadedVideo)
    }
    useEffect(() => {
            getCurrTime()
    }, []);

    // Added by rahul for scorm test
    useEffect(() => {

        // INSTEAD OF LOCALSTORAGE WE CAN USE 
        // axios.post('/api/scorm-track', {
        //     key,
        //     value,
        //     content_id: RouteParams['id'],
        //     user_id: user.id
        // });

        (window as any).API = {
            LMSInitialize: () => {
                console.log("SCORM: Initialize");
                return "true";
            },
            LMSFinish: () => {
                console.log("SCORM: Finish");
                return "true";
            },
            LMSGetValue: (key: any) => {
                console.log("SCORM: Get", key);
                return localStorage.getItem(key) || "";
            },
            LMSSetValue: (key: any, value: any) => {
                console.log("SCORM: Set", key, value);
                localStorage.setItem(key, value);
                return "true";
            },
            LMSCommit: () => {
                console.log("SCORM: Commit");
                return "true";
            },
            LMSGetLastError: () => "0",
            LMSGetErrorString: () => "No error",
            LMSGetDiagnostic: () => "No diagnostic"
        };

        const originalSetValue = (window as any).API.LMSSetValue;

        (window as any).API.LMSSetValue = function(element:any, value:any) {

            // console.log("SET", element, value);

            if (element.startsWith("cmi.interactions")) {
            console.log("INTERACTION:", element, value);
            }

            return originalSetValue.apply(this, arguments);
        };

        console.log("Scorm -", (window as any));
        return () => {
            delete (window as any).API;
        };
    }, []);

    const handleVideoMounted = (element : any) => {
        if (element !== null) {
            console.log('element',element);
            const params = {
                content_id : RouteParams['id'],
                currenttime : Math.round(element.currentTime) - 1,
            }
            console.log("before db save ",  element.currentTime - 1);
            if(element.currentTime !== 0){
                API_SERVICE.setVideoCurrTime(params).then((msg) => {
                    console.log('msg')
                })
            }
        }
      };
    
    let i = 0;
    function videoStoppedPlaying() {
        handleVideoMounted(uploadedVideo)
        
    }
    const refreshContent = async () => {
        setLoadingContent(true);
        API_SERVICE.fetchContentById(RouteParams['id']).then((c) => {
            
            setContentQuiz(c.data.data);
            vidQuiz = c?.data?.data?.video_quiz;

            console.log("vidQuizData", vidQuiz);
            console.log('getContent',c);
            setCurrentQuestionIndex(0);
            setIframeScormUrl(`${Parameters.ScormBaseUrl}/${c.data?.data?.scorm_index || ''}`);
        }).catch((e) => {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        }).finally(() => {
            setLoadingContent(false);
        });
    };
    useEffect(() => {
        refreshContent();
        setShowQuizCompletionData(null);
    }, [location]);
    const refresh = async () => {
        setLoading(true);
        API_SERVICE.fetchCourseById(RouteParams['courseId']).then((courses) => {
            setCourse(courses.data.data);
        }).catch((e) => {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        }).finally(() => {
            // refreshContent();
            setLoading(false);
        });
        
    };

    const refreshCourseComplete = async () => {
        console.log('refreshCourseComplete hitted');
        
        API_SERVICE.createCourseComplete(RouteParams['courseId'],RouteParams['id']).then((d) => {
            
        }).catch((e) => {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        }).finally(() => {
            // refreshContent();
            
        });

    };
    const refreshAddProgress = async () => {
        console.log('refreshAddProgress hitted');
        
        API_SERVICE.courseAddProgress(RouteParams['courseId'],RouteParams['id']).then((d) => {
            
        }).catch((e) => {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        }).finally(() => {
            // refreshContent();
           
        });

    };
    useEffect(() => {
        refresh();
    }, []);
    useEffect(() => {
        if(contentType !== 'quiz' && videoId == 0 && contentType !== ''){
            refreshCourseComplete();
            refreshAddProgress();
            console.log("content type",contentType)
        }
    },[contentType])

    const renderVideoQuiz = () => {
        console.log('videoQuiz',videoQuiz)
        if (!(videoQuiz && videoQuiz.questions && videoQuiz.questions[currentQuestionIndex])) {
            return <>NA</>;
        }
        if(videoQuiz){
            pauseVideo();
        }

        if (showQuizCompletionData) {
            return <div className="text-center" style={{marginTop: '12%',marginBottom: '12%'}}>
                    <h2 className="mb-4">{videoQuiz?.title}{t('genDict.quizCompleted')}</h2>
                    <h5 className="mb-4">{videoQuiz.title}</h5>
                    <p className="text-secondary">{t('genDict.yourScore')} {showQuizCompletionData.user_score}/{showQuizCompletionData.total_score}</p>
                    {showVideoQuizResultTag((parseFloat(showQuizCompletionData.user_score) / parseFloat(showQuizCompletionData.total_score)))}<br/>
                </div>
        }
        const question = videoQuiz.questions[currentQuestionIndex];
        const options: any[] = [];
        if (question.options && question.options.length) {
            question.options.forEach((option: any, index: number) => {
                options.push(<div className="form-check mb-2" onClick={(() => {
                        if (question.type === 'radio') {
                            question.options.forEach((o: any) => {
                                if (o.id !== option.id)
                                    o.selected = false;
                            });

                        }
                        option.selected = !option.selected;
                        setContentQuiz(JSON.parse(JSON.stringify(videoQuiz)));
                    })}>
                        <div className="form-check form-check-label">
                            <div className="br-5px p-2 pt-4 pb-4 ans-options d-flex">
                                <Checkbox checked={option.selected} className="mr-2" />
                                <span dangerouslySetInnerHTML={{ __html: option.title }} />
                            </div>
                        </div>
                    </div>
                );
            });
        } else {
            options.push(
                <Input value={question.solution} onChange={(e) => {
                    question.solution = e.target.value;
                    setContentQuiz(JSON.parse(JSON.stringify(videoQuiz)));
                }} />,
            );
        }
        return <>
            <div className={'quiz-inner-wrapper'}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="bg-white p-3 br-5px pos-relative" style={{minHeight:'500px'}}>

                            {toggleStarter && <div className="quiz-starter text-center">
                                <h2 className="mb-4">{videoQuiz?.title} {t('genDict.Quiz')}</h2>
                                <h5 className="mb-4">{content.title}</h5>
                                <p>{t('genDict.Clickstartwhenyouready')}</p>
                                <button type="button" className="btn btn-lg btn-quiz-start text-uppercase" onClick={() => {
                                    setToggleStarter(false);
                                }}>start</button>
                            </div>}

                            {!toggleStarter && <div className="quiz-question p-sm-5" style={{maxWidth: "750px"}}>
                                <p className="mb-5 mt-3 InterMedium d-flex"><span className="mr-3">{currentQuestionIndex + 1}. </span><span className='QuestionTitleFront' dangerouslySetInnerHTML={{ __html: question.title }} /></p>
                                <div className="quiz-options">
                                    {
                                        options
                                    }
                                </div>
                                <div className="d-flex align-items-center justify-content-space-between mt-4">
                                    <div className="pl-5">
                                        {currentQuestionIndex !== 0 && <button type="button" className="btn btn-blue br-0px text-uppercase" onClick={() => {
                                            setCurrentQuestionIndex(currentQuestionIndex - 1);
                                        }}>{t('genDict.previous')}</button>}
                                        {videoQuiz.questions[currentQuestionIndex + 1] && <button type="button" className="btn btn-blue br-0px text-uppercase" disabled={!videoQuiz.questions[currentQuestionIndex + 1]}
                                        onClick={() => setCurrentQuestionIndex(currentQuestionIndex + 1)
                                        }>{t('genDict.next')}</button>}
                                        {
                                            !videoQuiz.questions[currentQuestionIndex + 1] &&
                                            <Button loading={submittingQuestion} onClick={async () => {
                                                const reqData: any = { solutions: [] };
                                                console.log(videoQuiz);
                                                videoQuiz.questions.forEach((q: any) => {
                                                    if (q.type === 'text') {
                                                        reqData.solutions.push({ question_id: q.id, solution: q.solution });
                                                    } else if (q.options) {
                                                        const o: any = [];
                                                        q.options.forEach((op: any) => {
                                                            if (op.selected) {
                                                                o.push(op.id);
                                                            }
                                                        });
                                                        reqData.solutions.push({ question_id: q.id, solution_id: o });
                                                    }
                                                });
                                                // setSubmittingQuestion(true);
                                                try {
                                                    const { data: { data } } = await API_SERVICE.submitQuiz(reqData, RouteParams['courseId'], videoQuiz.id);
                                                    setShowQuizCompletionData(data);
                                                    // refreshCourseComplete()
                                                    // refreshAddProgress()
                                                } catch (e) {
                                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                                } finally {
                                                    setSubmittingQuestion(false);

                                                }

                                            }} className="btn btn-blue br-0px text-uppercase">
                                                {t('genDict.submit')}
                                            </Button>
                                        }
                                    </div>
                                    <div>
                                        <span className="small text-secondary">{t('genDict.questions')} {currentQuestionIndex + 1}/{videoQuiz.questions.length}</span>
                                    </div>
                                </div>
                            </div>}
                            
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </>;
    };
    const showVideoQuizResultTag = (score: number) => {
        if (score < 0.2) {
            return <>
                <button type="button" className="btn btn-danger br-0px">{t('course.failed')}</button><br/>
                <button type="button" className="btn mt-4 btn-blue br-0px text-uppercase" 
                    onClick={() => 
                    {   
                        let VideoQuizresultModal = document.getElementById("VideoQuizModal") as HTMLElement
                        VideoQuizresultModal.style.display = "none";
                        let bodyTag = document.getElementById("body") as HTMLElement
                        bodyTag.style.overflow = 'auto';
                        setCurrentQuestionIndex(0)
                        setShowQuizCompletionData(null)
                    }}
                >Exit</button>
            </>
        }
        if (score < 0.6) {
            return <>
                <button type="button" className="btn btn-warning br-0px">{t('course.average')}</button><br/>
                <button type="button" className="btn mt-4 btn-blue br-0px text-uppercase" 
                    onClick={() => 
                    {   
                        let VideoQuizresultModal = document.getElementById("VideoQuizModal") as HTMLElement
                        VideoQuizresultModal.style.display = "none";
                        let bodyTag = document.getElementById("body") as HTMLElement
                        bodyTag.style.overflow = 'auto';
                        setCurrentQuestionIndex(0)
                        setShowQuizCompletionData(null)
                    }}
                >Exit</button>
            </>
        }
        if (score < 0.9) {
            return <>
                <button type="button" className="btn btn-blue br-0px">{t('course.good')}</button><br/>
                <button type="button" className="btn mt-4 btn-blue br-0px text-uppercase" 
                    onClick={() => 
                    {   
                        let VideoQuizresultModal = document.getElementById("VideoQuizModal") as HTMLElement
                        VideoQuizresultModal.style.display = "none";
                        let bodyTag = document.getElementById("body") as HTMLElement
                        bodyTag.style.overflow = 'auto';
                        setCurrentQuestionIndex(0)
                        setShowQuizCompletionData(null)
                    }}
                >Exit</button>
            </>
        }
        return <>
            <button type="button" className="btn btn-success br-0px">{t('course.excellent')}</button><br/>
            <button type="button" className="btn mt-4 btn-blue br-0px text-uppercase" 
                onClick={() => 
                {   
                    let VideoQuizresultModal = document.getElementById("VideoQuizModal") as HTMLElement
                    VideoQuizresultModal.style.display = "none";
                    let bodyTag = document.getElementById("body") as HTMLElement
                    bodyTag.style.overflow = 'auto';
                    setVideoQuiz(null);
                    setCurrentQuestionIndex(0)
                    setShowQuizCompletionData(null);
                    continueVideo();
                    const popCurrentQuiz = vidQuiz.filter((item : any) => item.id !== videoQuiz.id);
                    console.log('popCurrentQuiz',popCurrentQuiz)
                    vidQuiz = popCurrentQuiz;

                    API_SERVICE.createCourseComplete(RouteParams['courseId'],videoQuiz.id).then((d) => {
                        // setLoading(false);
                    }).catch((e) => {
                        notification.error({
                            message: API_SERVICE.handleErrors(e),
                        });
                    }).finally(() => {
                        // refreshContent();
                        // setLoading(false);
                    });
                    API_SERVICE.courseAddProgress(RouteParams['courseId'],videoQuiz.id).then((d) => {
                        // setLoading(false);
                    }).catch((e) => {
                        notification.error({
                            message: API_SERVICE.handleErrors(e),
                        });
                    }).finally(() => {
                        // refreshContent();
                        // setLoading(false);
                    });
                }}
            >{t('genDict.ContinuetoVideo')}</button>
        </>
    };
    const renderQuiz = () => {
        if (!(contentQuiz && contentQuiz.questions && contentQuiz.questions[currentQuestionIndex])) {
            return <>NA</>;
        }

        if (showQuizCompletionData) {
            return <div className="text-center" style={{marginTop: '12%',marginBottom: '12%'}}>
                    <h2 className="mb-4">{contentQuiz?.curriculum?.title} {t('genDict.quizCompleted')}</h2>
                    <h5 className="mb-4">{contentQuiz.title}</h5>
                    <p className="text-secondary"> {t('genDict.yourScore')} {showQuizCompletionData.user_score}/{showQuizCompletionData.total_score}</p>
                    {showResultTag((parseFloat(showQuizCompletionData.user_score) / parseFloat(showQuizCompletionData.total_score)))}<br/>
                </div>
        }
        const question = contentQuiz.questions[currentQuestionIndex];
        const options: any[] = [];
        if (question.options && question.options.length) {
            question.options.forEach((option: any, index: number) => {
                options.push(<div className="form-check mb-2" onClick={(() => {
                        if (question.type === 'radio') {
                            question.options.forEach((o: any) => {
                                if (o.id !== option.id)
                                    o.selected = false;
                            });

                        }
                        option.selected = !option.selected;
                        setContentQuiz(JSON.parse(JSON.stringify(contentQuiz)));
                    })}>
                        <div className="form-check form-check-label">
                            <div className="br-5px p-2 pt-4 pb-4 ans-options d-flex">
                                <Checkbox checked={option.selected} className="mr-2" />
                                <span dangerouslySetInnerHTML={{ __html: option.title }} />
                            </div>
                        </div>
                    </div>
                );
            });
        } else {
            options.push(
                <Input value={question.solution} onChange={(e) => {
                    question.solution = e.target.value;
                    setContentQuiz(JSON.parse(JSON.stringify(contentQuiz)));
                }} />,
            );
        }
        return <>
            <div className={'quiz-inner-wrapper'}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="bg-white p-3 br-5px pos-relative" style={{minHeight:'500px'}}>

                            {toggleStarter && <div className="quiz-starter text-center">
                                <h2 className="mb-4">{contentQuiz?.curriculum?.title} {t('genDict.Quiz')}</h2>
                                <h5 className="mb-4">{content.title}</h5>
                                <p>{t('genDict.Clickstartwhenyouready')}</p>
                                <button type="button" className="btn btn-lg btn-quiz-start text-uppercase" onClick={() => {
                                    setToggleStarter(false);
                                }}>{t('genDict.start')}</button>
                            </div>}

                            {!toggleStarter && <div className="quiz-question p-sm-5" style={{maxWidth: "750px"}}>
                                <p className="mb-5 mt-3 InterMedium d-flex"><span className="mr-3">{currentQuestionIndex + 1}. </span><span className='QuestionTitleFront' dangerouslySetInnerHTML={{ __html: question.title }} /></p>
                                <div className="quiz-options">
                                    {
                                        options
                                    }
                                </div>
                                <div className="d-flex align-items-center justify-content-space-between mt-4">
                                    <div className="pl-5">
                                        {currentQuestionIndex !== 0 && <button type="button" className="btn btn-blue br-0px text-uppercase" onClick={() => {
                                            setCurrentQuestionIndex(currentQuestionIndex - 1);
                                        }}>{t('genDict.previous')}</button>}
                                        {contentQuiz.questions[currentQuestionIndex + 1] && <button type="button" className="btn btn-blue br-0px text-uppercase" disabled={!contentQuiz.questions[currentQuestionIndex + 1]}
                                        onClick={() => setCurrentQuestionIndex(currentQuestionIndex + 1)
                                        }>{t('genDict.next')}</button>}
                                        {
                                            !contentQuiz.questions[currentQuestionIndex + 1] &&
                                            <Button loading={submittingQuestion} onClick={async () => {
                                                const reqData: any = { solutions: [] };
                                                console.log(contentQuiz);
                                                contentQuiz.questions.forEach((q: any) => {
                                                    if (q.type === 'text') {
                                                        reqData.solutions.push({ question_id: q.id, solution: q.solution });
                                                    } else if (q.options) {
                                                        const o: any = [];
                                                        q.options.forEach((op: any) => {
                                                            if (op.selected) {
                                                                o.push(op.id);
                                                            }
                                                        });
                                                        reqData.solutions.push({ question_id: q.id, solution_id: o });
                                                    }
                                                });
                                                setSubmittingQuestion(true);
                                                try {
                                                    const { data: { data } } = await API_SERVICE.submitQuiz(reqData, RouteParams['courseId'], RouteParams['id']);
                                                    setShowQuizCompletionData(data);
                                                } catch (e) {
                                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                                } finally {
                                                    setSubmittingQuestion(false);

                                                }

                                            }} className="btn btn-blue br-0px text-uppercase">
                                                {t('genDict.submit')}
                                            </Button>
                                        }
                                    </div>
                                    <div>
                                        <span className="small text-secondary">{t('genDict.next')} {currentQuestionIndex + 1}/{contentQuiz.questions.length}</span>
                                    </div>
                                </div>
                            </div>}
                            
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </>;
    };
    const showResultTag = (score: number) => {
        if (score < 0.2) {
            return <><button type="button" className="btn btn-danger br-0px">{t('course.failed')}</button><br />
                <button type="button" className="btn mt-4 btn-blue br-0px text-uppercase" 
                    onClick={() => 
                    {
                        setShowQuizCompletionData(null)
                        history.push(`/my/courses/${course.id}`);
                    }}
                >
                    {t('genDict.Exit')}
                </button>
                </>
        }
        if (score < 0.6) {
            return <><button type="button" className="btn btn-warning br-0px">{t('course.average')}</button><br />
                <button type="button" className="btn mt-4 btn-blue br-0px text-uppercase" 
                    onClick={() => 
                    {
                        setShowQuizCompletionData(null)
                        history.push(`/my/courses/${course.id}`);
                    }}
                >
                    {t('genDict.Exit')}
                </button>
                </>
        }
        if (score < 0.9) {
            return <><button type="button" className="btn btn-blue br-0px">{t('course.good')}</button><br />
                <button type="button" className="btn mt-4 btn-blue br-0px text-uppercase" 
                    onClick={() => 
                    {
                        setShowQuizCompletionData(null)
                        history.push(`/my/courses/${course.id}`);
                    }}
                >
                   {t('genDict.Exit')}
                </button>
                </>
        }
        return <><button type="button" className="btn btn-success br-0px">{t('course.excellent')}</button><br />
                <button type="button" className="btn mt-4 btn-blue br-0px text-uppercase" 
                    onClick={() => 
                    {
                        setShowQuizCompletionData(null)
                        refreshCourseComplete()
                        refreshAddProgress()
                        // history.push(`/my/courses/${course.id}`); THIS LINK IS BROKEN
                        history.push(`/courses/${course.id}`);
                    }}
                >
                   {t('genDict.Gobacktocourse')}
                </button>
                </>
    };
    const renderContentViews = () => {
        if (course && course.curriculums)
            course.curriculums.forEach((cu: any) => {
                if (cu.contents)
                    cu.contents.forEach((c: any) => {
                        if (c.id === parseInt(RouteParams['id'])) {
                            content = c;
                            setContentType(c.type);
                            setVideoId(c.video_id);
                            
                        }
                    });
            });
        if (loadingContent) {
            return <Skeleton active={true} />;
        }
        console.log('contentType',contentType, typeof contentType);
        
        
        switch (content.type) {
            case 'lecture':
                if (content.youtube_url) {
                    return <iframe width='100%' height={'480'}
                                //    src={'https://www.youtube.com/embed/' + content.youtube_url}
                                src={content.youtube_url}
                                   frameBorder='0'
                                   allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                                   allowFullScreen />
                                   
                } else if (content.video) {
                    return <video id="uploadedVideo" width='100%' controls>
                        <source
                            src={Parameters.BaseUrl + '/' + 'storage/uploads/' + content.video.slug + content.video.ext}
                            type={content.video.mime_type} />
                    </video>;
                } else if (content.external_url) {
                    return <video src={content.external_url} width='100%' controls />;
                } else if (content.vimeo_url) {
                    return <iframe 
                    // src={'https://player.vimeo.com/video/' + content.vimeo_url}
                    src={content.vimeo_url} 
                    width='100%' height={'480'}
                                   frameBorder='0' allow='autoplay; fullscreen; picture-in-picture'
                                   allowFullScreen></iframe>;
                }
                break;
            case 'assignment' :
                if (content && content.html_index) {
                    // @ts-ignore
                    return <iframe className={'content-frame'} frameborder='0'
                                   src={Parameters.BaseUrl + '/' + content.html_index} style={{width: '100%'}} />;
                }
                try {
                    return content && content.attachments && content.attachments[0] && content.attachments[0].media ?
                        <iframe className={'content-frame'}
                        src={'https://docs.google.com/gview?url='+getAttachmentsUrl(content.attachments[0].media)+'&embedded=true'}
                            // @ts-ignore
                                frameborder='0' width='100%' height="500px" /> : <h1>{t('genDict.noContentAvailable')}</h1>;

                } catch (e) {
                    return <></>;
                }
            case 'html' :
                if (content && content.html_index) {
                    // @ts-ignore
                    return <iframe className={'content-frame'} frameborder='0'
                                   src={Parameters.BaseUrl + '/' + content.html_index} />;
                }
                return <></>;

            case 'scorm' :
                // return <iframe style={{ width: '100%', height: fullScreen ? '100vh' : '600px', border: 'none' }}
                            //    src={Parameters.ApiUrl + '/' + `courses/${RouteParams['courseId']}/curriculums/${RouteParams['curriculumId']}/contents/${RouteParams['id']}/sco`} />;
                               return <iframe style={{ width: '100%', height: fullScreen ? '100vh' : '600px', border: 'none' }} src={iframeScormUrl} />;
            case 'quiz' :
                return <div className={'quiz-wrapper'}>{renderQuiz()}</div>;
        }
        return <></>;
    };
    if (loading || !course) {
        return <Skeleton active={true} />;
    }
    
    return (
        <AuthConsumer>
            {({ isAuth, updateCartTime }) =>
                <Layout className={'content-details-page'}>
                    {/* <Sider width={450} className='site-layout-background'>

                        <Tabs defaultActiveKey='1'>
                            <TabPane tab={t('genDict.curriculums')} key='1'>
                                <CurriculumList course={course} />
                            </TabPane>
                            <TabPane tab={t('genDict.meetings')} key='2'>
                                <MeetingsList course={course} />
                            </TabPane>
                        </Tabs>
                    </Sider> */}
                    <Layout>
                        <Content
                            className='site-layout-background pt-3 pb-3'
                            style={{
                                margin: 0,
                                position: 'relative',
                                minHeight: 500,
                            }}>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="bg-white p-3 br-5px frontend-single-course" style={{minHeight: '500px'}}>
                                            <div className="row">
                                                <div className="col-md-12 pb-3">
                                                    <div className="row m-0">
                                                        
                                                        <div className={`mt-4 mt-md-0 light-shadow ${contentType === 'quiz' ? "col-md-12" : "col-lg-8 col-md-7"}`}>
                                                            <div className={`text-center content-details pt-3`}>
                                                                {
                                                                    renderContentViews()
                                                                }
                                                            </div>
                                                            {/* {content && contentType !== 'quiz' && <div className="mt-2 mb-3 course-video-desc bg-f9fafb light-shadow p-3">
                                                                
                                                                <p className="InterMedium title" style={{fontSize:'18px'}}>{content.title}</p>
                                                                <p>{
                                                                    content && <div dangerouslySetInnerHTML={{ __html: content.description }} />
                                                                }</p>
                                                            </div>} */}
                                                        </div>
                                                        
                                                        {contentType !== 'quiz' && <div className="col-lg-4 col-md-5 mt-4 mt-md-0 pl-4 pr-4 light-shadow">
                                                            <div className="about-course mt-4">
                                                                <h4>{t('genDict.AboutThisCourse')}</h4>
                                                                <div className="d-flex mt-3 mb-3 align-items-center">
                                                                <div className="mr-3">
                                                                    <img src={Parameters.ImageBaseUrl + course.author.avatar_image.slug + course.author.avatar_image.ext} className="uploaded-img-cat" height="65" width="65" />
                                                                </div>
                                                                <div className="">
                                                                    <h5 className="mb-0 font-18px">{course?.author?.name}</h5>
                                                                    <p className="mb-0 text-secondary">{t('genDict.Instructor')}</p>
                                                                </div>
                                                                </div>
                                                                <div className="desc">
                                                                    <p className="mb-0">{course?.author?.about_me} </p>
                                                                </div>
                                                            </div>
                                                            {/*<hr/>
                                                             <div className="course-completion">
                                                                <h4 className="mb-3">{t('genDict.CourseCompletion')}</h4>
                                                                <div className="pos-relative">
                                                                    <span className="float-left">{Math.round(course.completion_percentage)}% {t('genDict.Completed')}</span>
                                                                    <span className="float-right">{t('genDict.Module')} {course.complete_modules}/{course.total_modules}</span>
                                                                    <div className="progress" style={{background:"linear-gradient(to right, #34d399 "+`${course.completion_percentage}`+"%,#efefef 0)"}}></div>
                                                                </div>
                                                                <ul className="list-style-none mt-4">
                                                                    {course.curriculums && course.curriculums.map((moduleItem: any,cindex:any) => {
                                                
                                                                        return moduleItem.contents && moduleItem.contents.map((moduleContent: any,index:any) => {
                                                                            console.log("moduleContent",moduleContent)
                                                                            return <li className="mb-4">
                                                                                <div className="d-flex">
                                                                                    {moduleContent.is_complete ? 
                                                                                        <img src={benefitCheck} className="mr-3 mt-1 benefit-check" />
                                                                                    :
                                                                                        <span className="text-secondary mr-3">0{index + 1}</span>
                                                                                    }
                                                                                    <span role="button" className='text-4f46e5 w-100'
                                                                                        onClick={() => {
                                                                                            history.push("/courses/"+course.id+"/curriculums/"+moduleItem.id+"/contents/"+moduleContent.id)
                                                                                        }}
                                                                                        >{moduleContent?.title}
                                                                                        {moduleContent.type == 'quiz' && moduleContent.activity != null ? <><br /><span className="small text-secondary">
                                                                                            {moduleContent.activity != null ?
                                                                                                Math.round(moduleContent.activity.user_score) + '/' + Math.round(moduleContent.activity.total_score)
                                                                                                : 'Not Yet Completed'}
                                                                                        </span><span className="small text-secondary float-right">
                                                                                                {moduleContent.activity != null ?
                                                                                                    moduleContent.activity.user_score === moduleContent.activity.total_score ? "Pass" : "Fail"
                                                                                                    :
                                                                                                    ''}
                                                                                            </span></>
                                                                                        :<></>}
                                                                                    </span>
                                                                                    
                                                                                </div>
                                                                            </li>
                                                                        })
                                                                    })}
                                                                </ul>
                                                            </div> */}
                                                        </div>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="videoQuizModal" id="VideoQuizModal">
                                    <div className='modalQuizVideoDialog'>
                                        <div className='modalQuizVideoContent'>
                                        <div className={'quiz-wrapper'}>{renderVideoQuiz()}</div>
                                            {/* <h1>What is Lorem Ipsum?</h1>
                                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                                            <h1>What is Lorem Ipsum?</h1>
                                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                                            <h1>What is Lorem Ipsum?</h1>
                                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p> */}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </Content>
                    </Layout>
                </Layout>
            }
        </AuthConsumer>

    );
}

function CurriculumList(
    {
        course,
    }
        : any) {
    const { t }: any = useTranslation();
    return <div className={'curriculum-wrapper'}>
        {
            course.curriculums.map((curriculum: any) => {
                return <>
                    <Title level={4}>{curriculum.title}</Title>
                    {
                        curriculum.contents.map((content: any) => {
                            return <div style={{ margin: '7px 0' }}>
                                <Row gutter={20} align={'top'} wrap={false}>
                                    <Col className={'icon-size-30'}>
                                        {
                                            content.type === 'lecture' &&
                                            <PlayCircleTwoTone />
                                        }
                                        {
                                            content.type === 'scorm' &&
                                            <FolderOpenTwoTone />
                                        }
                                        {
                                            content.type === 'assignment' &&
                                            <FolderOpenTwoTone />
                                        }
                                        {
                                            content.type === 'quiz' &&
                                            <QuestionCircleTwoTone />
                                        }
                                    </Col>
                                    <Col flex={'auto'}>
                                        <Link
                                            to={`/courses/${course.id}/curriculums/${curriculum.id}/contents/${content.id}`}
                                            onClick={(e) => {
                                                // if (!course.isOrdered && !content.is_preview) {
                                                //     e.preventDefault();
                                                //     e.stopPropagation();
                                                //     notification.error({ message: t('courses.purchaseCourseFirst') });
                                                // }
                                            }}>{content.title}</Link>
                                        <div dangerouslySetInnerHTML={{ __html: content.description }}>
                                        </div>
                                        <div style={{ textAlign: 'right' }}>
                                            <Text disabled>
                                                {content.duration_in_minutes}&nbsp;
                                                {t('genDict.minutes')}
                                            </Text>
                                        </div>

                                    </Col>
                                </Row>
                            </div>;
                        })
                    }
                    <br />
                </>;
            })
        }
    </div>;
}

function MeetingsList(
    {
        course,
    }
        : any) {
    const { t }: any = useTranslation();
    const [meetings, setMeetings] = useState([] as any[]);
    const [loading, setLoading] = useState(false);
    const [joining, setJoining] = useState(-1);
    useEffect(() => {
        setLoading(true);
        API_SERVICE.fetchMeetingsByCourseId(course.id).then((m) => {
            setMeetings(m.data.data.items);
        }).catch((e) => {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        }).finally(() => {
            // refreshContent();
            setLoading(false);
        });
    }, []);
    if (loading) {
        return <Spin />;
    }
    return <div className={'curriculum-wrapper'}>
        {
            meetings.map((meeting: any, index: number) => {
                return <div>
                    <Row gutter={[20, 20]}>
                        <Col flex={'auto'}>
                            <Text>{meeting.title}</Text>
                            <div>
                                <Text disabled>{moment(meeting.start_date_time).format('LL')}</Text>
                            </div>
                        </Col>
                        <Col>
                            <Button type='primary' loading={joining === index} icon={<EyeFilled />}
                                    onClick={() => {
                                        setJoining(index);
                                        API_SERVICE.joinMeetingClient(course.id, meeting.id).then(({ data: { data: { url } } }) => {
                                            notification.success({
                                                message: t('genDict.success'),
                                            });
                                            window.open('https://' + url);
                                        }).catch((e: any) => {
                                            notification.error({
                                                message: t(API_SERVICE.handleErrors(e)),
                                            });
                                        }).finally(() => {
                                            setJoining(-1);
                                        });
                                    }}>
                                {t('genDict.join')}
                            </Button>
                        </Col>
                    </Row>
                </div>;
            })
        }
    </div>;
}

